import { useState } from 'react'
import { TableContextValue } from './useTableContext'

export default function useTableMode() {
  const [mode, setMode] = useState<TableContextValue['mode']>('view')

  return { mode, setMode }
}
